// hooks/tiDemoData.ts
//
// Mock data for TI tab visual demo. Activated by VITE_TI_DEMO=true env var.
// Usage: VITE_TI_DEMO=true npm start

import type { Risk } from '@/types';

export const TI_DEMO_ENABLED =
  import.meta.env.VITE_TI_DEMO === 'true' ||
  import.meta.env.VITE_TI_DEMO === '1';

function fakeRisks(prefix: string, count: number, titlePrefix: string): Risk[] {
  return Array.from({ length: count }, (_, i) => {
    // Spread entries across multiple months (Jan–Apr 2026)
    // so the timeline adjusts horizontally as pages load
    const baseDate = new Date(2026, 0, 1); // Jan 1 2026
    baseDate.setHours((i * 7) % 24);
    baseDate.setDate(1 + (i % 120)); // spreads over ~4 months
    const ts = baseDate.toISOString();
    return {
      key: `#risk#example.com#${prefix}/${String(i + 1).padStart(3, '0')}`,
      name: `${prefix}/${String(i + 1).padStart(3, '0')}`,
      dns: 'example.com',
      status: ['TH', 'OH', 'TI', 'OC'][i % 4],
      priority: 10 + (i % 50),
      created: ts,
      updated: ts,
      visited: ts,
      ttl: 0,
      source: 'recorded-future',
      history: [],
      ti_provider: {
        ti_discovery_timestamp: ts,
        ti_data: {
          title: `${titlePrefix} ${i + 1}`,
          triggered: ts,
        },
      },
      title: `${titlePrefix} ${i + 1}`,
    } as unknown as Risk;
  });
}

export const DEMO_RISKS: Record<string, Risk[]> = {
  'rf-ioc': fakeRisks('rf-ioc', 500, 'Malicious IOC'),
  'rf-alert': fakeRisks('rf-alert', 12, 'Threat Alert'),
  'rf-playbook-alert': fakeRisks('rf-playbook-alert', 5, 'Playbook Alert'),
  'rf-threat-actor': fakeRisks('rf-threat-actor', 8, 'Threat Actor'),
  'rf-threat-malware': fakeRisks('rf-threat-malware', 3, 'Malware Variant'),
  'rf-detection-rule': fakeRisks('rf-detection-rule', 21, 'Detection Rule'),
  'rf-identity': fakeRisks('rf-identity', 6, 'Credential Exposure'),
  'rf-analyst-note': fakeRisks('rf-analyst-note', 4, 'Analyst Note'),
};
